import { BrandCaptionLowerThirdEntity } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandCaptionLowerThirdUpdateResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandCaptionLowerThirdUpdateResponseDTO.validationSchema()
  );

  constructor(readonly data: RoomBrandCaptionLowerThirdUpdateResponse) {
    JsonSchemaValidator.validate(
      RoomBrandCaptionLowerThirdUpdateResponseDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["caption"],
      properties: {
        caption: {
          instanceof: BrandCaptionLowerThirdEntity.name
        }
      }
    };
  }
}

interface RoomBrandCaptionLowerThirdUpdateResponse {
  caption: BrandCaptionLowerThirdEntity;
}
